module.exports = __webpack_public_path__ + "img/天然水晶生肖.8c89793e.jpg";